// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useEffect, useState } from 'react';
import { Logger, API } from 'aws-amplify';
import ReactAudioPlayer from 'react-audio-player';

import useAppContext from '../../contexts/app';
import generateS3Url from '../../graphql/queries/generateS3Url';

const logger = new Logger('RecordingPlayer');

/* eslint-disable react/prop-types, react/destructuring-assignment */
export const RecordingPlayer = ({ callId }) => {
  const [preSignedUrl, setPreSignedUrl] = useState();
  const { setErrorMessage, user } = useAppContext();

  useEffect(() => {
    const getPresignedUrl = async () => {
      if (callId && user?.signInUserSession?.accessToken?.jwtToken) {
        logger.debug('generate presigned URL for call id:', callId);
        try {
          const accessToken = user?.signInUserSession?.accessToken?.jwtToken;
          const response = await API.graphql({
            query: generateS3Url,
            variables: {
              callId,
              accessToken,
            },
          });

          const presignedUrl = response.data.generateS3Url;
          logger.debug('recording presigned url received', presignedUrl);
          setPreSignedUrl(presignedUrl);
        } catch (error) {
          setErrorMessage('failed to get recording url - please try again later');
          logger.error('failed generate recording s3 url', error);
        }
      }
    };

    getPresignedUrl();
  }, [callId, user]);

  return preSignedUrl?.length ? <ReactAudioPlayer src={preSignedUrl} controls /> : null;
};

export default RecordingPlayer;
